var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',_vm._b({},'form-group',_vm.$attrs,false),[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('bloqueio-options',{attrs:{"payload":_vm.payload}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('select-conta-id',{attrs:{"payload":_vm.payload}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }